import { IMAGE_POSITION_BACKGROUND } from '../../constants';

export function isBackgroundPositionAvailable(images) {
  return images.length < 2;
}

export function isBackgroundSelected(currentPosition) {
  return currentPosition === IMAGE_POSITION_BACKGROUND;
}
